import React from 'react';
import { useLocation } from 'react-router-dom';

interface ScrollToTopProps {}

const ScrollToTop: React.FC<ScrollToTopProps> = ({ children }) => {
  const { pathname, hash } = useLocation();

  React.useEffect(() => {
    if (hash) return;

    window.scrollTo(0, 0);
  }, [pathname]);

  return <>{children}</>;
};

export default ScrollToTop;
